module.exports = __webpack_public_path__ + "static/media/icon_share_facebook.f2563b7e.svg";